import { useEffect, useState } from "react";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import InputAddModal from "./InputAddModal/InputAddModal";
import "./ModalAddFamiliar.css";
import { useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import { hideModal } from "../../../context/Actions/modal/modal";
import {
  limpiarAddFamiliar,
  limpiarPostFamiliar,
  wsGetGrupoFamiliar,
  wsPostAgregarFamiliar,
  wsPutEditarDerechos,
} from "../../../context/Actions/grupoFamiliar/grupoFamiliar";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { IonSpinner } from "@ionic/react";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../../Genericos/InputV1/InputV1";
import { getListaFamiliares } from "_+_Portal/context/Actions/listaFamiliares/listasFamiliares";

const ModalAddFamiliar = ({
  idpaciente2,
  editar,
  nombre,
  familiarCompleto,
}) => {
  // traemos info del contexto global
  const {
    modalDispatch,
    grupoFamiliarDispatch,
    grupoFamiliarState,
    listaFamiliaresState,
    listaFamiliaresDispatch,
  } = useContext(PortalContext);

  // Cambio de contexto
  const { toasterDispatch } = useContext(GlobalContext);

  // formulario que se envia para poder crear y editar familiares
  const [form, setForm] = useState({
    abierta: true,
    idpaciente2: null,
    nro_documentoFamiliar: false,
    idpaciente2_desc: null,
    idparentescoproceso: false,
    idparentescoproceso_desc: false,
    tipoDerecho: {
      edicionPerfil: true,
      manejoTurnos: true,
      verResultados: true,
    },
    tipoDerechoMe: {
      edicionPerfil: true,
      manejoTurnos: true,
      verResultados: true,
    },
  });

  // onChange de parenntesco familiar
  // PF = Parentesco Familiar
  const onChangePF = (parentesco) => {
    //debe guardar el parentesco en el form
    setForm({
      ...form,
      idparentescoproceso: parentesco.id,
      idparentescoproceso_desc: parentesco.descripcion,
    });
  };

  // on cclic de los checkbox
  const handleClickCheck = (c) => {
    const id = c.target.id.slice(5, 6);
    const name = c.target.id.slice(6, c.target.id.lenght);
    if (id === "1") {
      setForm({
        ...form,
        tipoDerecho: {
          ...form.tipoDerecho,
          [name]: !form.tipoDerecho[name],
        },
      });
    }
    if (id === "2") {
      setForm({
        ...form,
        tipoDerechoMe: {
          ...form.tipoDerechoMe,
          [name]: !form.tipoDerechoMe[name],
        },
      });
    }
  };

  // cierra el modal
  const handleCloseModal = () => {
    if (!grupoFamiliarState.grupoFamiliar.familiar.loading) {
      hideModal()(modalDispatch);
      limpiarAddFamiliar()(grupoFamiliarDispatch);
    }
  };

  // submitea el formulario
  const handleSubmit = () => {
    if (
      (form.tipoDerecho.edicionPerfil ||
        form.tipoDerecho.manejoTurnos ||
        form.tipoDerecho.verResultados) &&
      (form.tipoDerechoMe.edicionPerfil ||
        form.tipoDerechoMe.manejoTurnos ||
        form.tipoDerechoMe.verResultados)
    ) {
      const yaExiste = grupoFamiliarState?.grupoFamiliar?.data.filter(
        (data) =>
          data.nroDocumentoFamiliar.toString() === form.nro_documentoFamiliar
      );
      if (yaExiste?.length > 0) {
        showToaster(
          {
            texto: "El familiar que intenta agregar ya existe.",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      } else {
        wsPostAgregarFamiliar(form, (isCorrect, data) => {
          if (isCorrect) {
            showToaster(
              {
                texto:
                  "El familiar fue creado correctamente. Queda pendiente la autorización de parte del familiar.",
                tipo: "success",
              },
              "centroArriba"
            )(toasterDispatch);
            getListaFamiliares(true)(listaFamiliaresDispatch);
            wsGetGrupoFamiliar(true)(grupoFamiliarDispatch);
          } else {
            showToaster(
              {
                texto: "El familiar no se ha creado.",
                tipo: "danger",
              },
              "centroArriba"
            )(toasterDispatch);
            limpiarPostFamiliar()(grupoFamiliarDispatch);
          }
        })(grupoFamiliarDispatch);
        limpiarPostFamiliar()(grupoFamiliarDispatch);
        limpiarAddFamiliar()(grupoFamiliarDispatch);
        hideModal()(modalDispatch);
      }
    } else {
      showToaster(
        {
          texto:
            "Debe seleccionar al menos un derecho para cada relación (permisos sobre uno y permisos sobre el otro usuario)",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  // enviar el dto para editar
  const handleClickEditar = () => {
    // debo hacer un dispatch
    wsPutEditarDerechos(form, (isCorrect) => {
      if (isCorrect) {
        showToaster(
          {
            texto: "Los derechos se han editado correctamente.",
            tipo: "success",
          },
          "centroArriba"
        )(toasterDispatch);
        getListaFamiliares(true)(listaFamiliaresDispatch);
        wsGetGrupoFamiliar(true)(grupoFamiliarDispatch);
      } else {
        showToaster(
          {
            texto: "Error al editar derechos.",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    })(grupoFamiliarDispatch);
    hideModal()(modalDispatch);
  };

  // use Effect que carga la información
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Esto sirve para poder tener los dropDowns cargados
    const parentescoData =
      grupoFamiliarState.grupoFamiliar.tiposParentesco.data;
    const listaFamiliares = listaFamiliaresState.listaFamiliares.data;
    if (
      editar &&
      Array.isArray(parentescoData) &&
      parentescoData.length > 0 &&
      Array.isArray(listaFamiliares) &&
      listaFamiliares.length > 0
    ) {
      let pariente = listaFamiliaresState.listaFamiliares.data.filter(
        (item) => idpaciente2 === item.id
      );
      pariente = pariente[0].paciente;

      const tipoDerecho = familiarCompleto.tipoDerecho;
      const tipoDerechoMe = familiarCompleto.tipoDerechoMe;
      const parentesco = familiarCompleto.parentesco;
      const newParentesco =
        grupoFamiliarState.grupoFamiliar.tiposParentesco.data.filter(
          (item) => parentesco === item.descripcion
        );

      setForm({
        ...form,
        abierta: true,
        idpaciente2,
        nro_documentoFamiliar: pariente.nro_documento,
        idpaciente2_desc: nombre,
        idparentescoproceso: newParentesco[0].id,
        idparentescoproceso_desc: newParentesco[0].descripcion, // familiarCompleto.tipoDerecho
        tipoDerecho: {
          edicionPerfil: !tipoDerecho
            ? false
            : familiarCompleto.tipoDerecho.edicionPerfil,
          manejoTurnos: !tipoDerecho
            ? false
            : familiarCompleto.tipoDerecho.manejoTurnos,
          verResultados: !tipoDerecho
            ? false
            : familiarCompleto.tipoDerecho.verResultados,
        },
        tipoDerechoMe: {
          edicionPerfil: !tipoDerechoMe
            ? false
            : familiarCompleto.tipoDerechoMe.edicionPerfil,
          manejoTurnos: !tipoDerechoMe
            ? false
            : familiarCompleto.tipoDerechoMe.manejoTurnos,
          verResultados: !tipoDerechoMe
            ? false
            : familiarCompleto.tipoDerechoMe.verResultados,
        },
      });
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [
    grupoFamiliarState.grupoFamiliar.tiposParentesco.data,
    listaFamiliaresState.listaFamiliares.data,
  ]);

  return (
    <div
      className={`ptur-modalAddFamiliar-container ${editar ? "height100" : ""}`}
    >
      {/* ------------- HEADER --------------------- */}
      <div className="ptur-modalAddFamiliar-header">
        <span className="ptur-modalAddFamiliar-header-title rb18m">
          {!editar ? "Agregar un nuevo familiar" : "Editar a un familiar"}
        </span>
        <span
          className="ptur-modalAddFamiliar-header-cruz"
          onClick={handleCloseModal}
        >
          X
        </span>
      </div>
      <div className="ptur-modalAddFamiliar-bodyContainer">
        {/* ------------- LEYENDAA --------------------- */}
        <div
          className={`ptur-modalAddFamiliar-leyenda ${
            editar ? "ptur-modalAddFamiliar-leyenda-1" : ""
          }`}
        >
          <span>
            El familiar que agregas tiene que estar inscripto en el Portal
          </span>
        </div>
        {/* ------------- BODY TOP--------------------- */}

        {!editar ? (
          <div className="ptur-modalAddFamiliar-body-top">
            <div className="ptur-modalAddFamiliar-body-DNI">
              <span className="ptur-modalAddFamiliar-body-DNI-text">
                DNI del familiar
              </span>
              <InputAddModal setForm={setForm} form={form} />
            </div>
            <div className="ptur-modalAddFamiliar-body-parentesco">
              <Dropdown
                name="familia"
                onChange={onChangePF}
                placeholder="Elegí una opción"
                headerStr="Parentesco Familiar"
                datos={grupoFamiliarState.grupoFamiliar.tiposParentesco.data}
                campoCodigo="id"
                descripcion="descripcion"
                errorStr="El parentesco es requerido"
                customCss={"ptur-modalAddFamiliar-body-parentesco-dropdown"}
              />
            </div>
          </div>
        ) : (
          ""
        )}

        {/* ------------- BODY MEDIUM--------------------- */}
        <div
          className={`ptur-modalAddFamiliar-body-permisosOtros-txtContainer `}
        >
          <span className="ptur-modalAddFamiliar-body-permisosOtros-txt">
            Los permisos de otros sobre mí:
          </span>
        </div>
        <div className="ptur-modalAddFamiliar-body-permisosOtros-input">
          {loading && editar ? (
            <IonSpinner name="lines" />
          ) : (
            <>
              <InputV1
                checkboxStr={"Edicion Perfil"}
                inputType={"check"}
                name="2edicionPerfil"
                id="2edicionPerfil"
                onChange={handleClickCheck}
                checked={form.tipoDerechoMe.edicionPerfil}
              />
              <InputV1
                checkboxStr={"Manejo Turnos"}
                inputType={"check"}
                name="2manejoTurnos"
                id="2manejoTurnos"
                onChange={handleClickCheck}
                checked={form.tipoDerechoMe.manejoTurnos}
              />
              <InputV1
                checkboxStr={"Ver Resultados"}
                inputType={"check"}
                name="2verResultados"
                id="2verResultados"
                onChange={handleClickCheck}
                checked={form.tipoDerechoMe.verResultados}
              />
            </>
          )}
        </div>
        <div className="ptur-modalAddFamiliar-body-permisosOtros-txtContainer">
          <span className="ptur-modalAddFamiliar-body-permisosOtros-txt">
            Mis permisos sobre otros:
          </span>
        </div>
        <div className="ptur-modalAddFamiliar-body-permisosOtros-input">
          {loading && editar ? (
            <IonSpinner name="lines" />
          ) : (
            <>
              <InputV1
                checkboxStr={"Edicion Perfil"}
                inputType={"check"}
                name="1edicionPerfil"
                id="1edicionPerfil"
                onChange={handleClickCheck}
                checked={form.tipoDerecho.edicionPerfil}
              />
              <InputV1
                checkboxStr={"Manejo Turnos"}
                inputType={"check"}
                name="1manejoTurnos"
                id="1manejoTurnos"
                onChange={handleClickCheck}
                checked={form.tipoDerecho.manejoTurnos}
              />
              <InputV1
                checkboxStr={"Ver Resultados"}
                inputType={"check"}
                name="1verResultados"
                id="1verResultados"
                onChange={handleClickCheck}
                checked={form.tipoDerecho.verResultados}
              />
            </>
          )}
        </div>

        {/* ------------- FOOTER--------------------- */}
        <div className="ptur-modalAddFamiliar-footer">
          <button
            className="ptur-modalAddFamiliar-footer-bt1"
            onClick={handleCloseModal}
          >
            Cancelar
          </button>
          {!editar ? (
            <button
              className={
                form.nro_documentoFamiliar && form.idparentescoproceso
                  ? "ptur-modalAddFamiliar-footer-btn2"
                  : "ptur-modalAddFamiliar-footer-btn2 disable-btn"
              }
              onClick={handleSubmit}
              disabled={
                form.nro_documentoFamiliar && form.idparentescoproceso
                  ? false
                  : true
              }
            >
              Agregar familiar
            </button>
          ) : (
            <button
              className="ptur-modalAddFamiliar-footer-btn2"
              onClick={handleClickEditar}
            >
              Editar al familiar
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalAddFamiliar;
